var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCommentFilter = function SvgIconCommentFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5V3m-3 2.5 3-3 3 3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.5V13m3-2.5-3 3-3-3"
  }))));
};
export default SvgIconCommentFilter;